import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Alert, Box, Button } from '@mui/material';
import { useStripeApi } from '../../hooks/useStripeApi';
import { StripeHero } from '../../components/stripe/stripeShared';

const StripeLayout: React.FC = () => {
  const { ready } = useStripeApi();
  const navigate = useNavigate();

  if (!ready) {
    return (
      <Box>
        <StripeHero subtitle="Connect your Stripe secret key to view balance, transactions, customers, subscriptions, and payouts." />
        <Alert
          severity="warning"
          action={
            <Button variant="contained" size="small" onClick={() => navigate('/settings#stripe')}>
              API settings
            </Button>
          }
        >
          Add your Stripe secret key in API settings (test <code>sk_test_…</code> recommended).
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1280 }}>
      <Outlet />
    </Box>
  );
};

export default StripeLayout;
